import AbstractSlider from '../../modules/slider';
import './style.less';

class TeacherSlider extends AbstractSlider {
    get mobileOptions() {
        return {
            slidesToShow: 1,
            dots: false,
            arrow: true
        };
    }

    get mobileBigOptions() {
        return {
            slidesToShow: 2,
            dots: false,
            arrow: true
        };
    }

    get tabletOptions() {
        return {
            slidesToShow: 3,
            dots: false,
            arrow: true
        };
    }

    get desktopOptions() {
        return {
            slidesToShow: 3,
            dots: false,
            arrow: true
        };
    }
}

$(window).load(() => {
    const teacherElement = $('.js-slick-teachers-list');
    if (teacherElement.length !== 0) {
        new TeacherSlider(teacherElement);
    }
});



// WEBPACK FOOTER //
// ./blocks/sem-teachers/index.js